/*
Edgeband
--thickness <float> | millimeters
--width <float> | inches
--certification <string::enum> | ['FSC', 'Standard', 'NAUF']
--finish <string::enum> | ['Matte', 'Gloss']
--color <string::enum> | ['White', 'Black']

--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/

import {
  certification,
  color,
  finish,
  thickness,
  width
} from '@/modules/standardItems/schemas/baseFilters'

export default [
  color(),
  certification(),
  finish(),
  thickness(),
  width()
]
